import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {APP_BASE_HREF, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {loginPath, mainPath, ssoPath, userPath} from './app-routing.constants';
import {ProfileApiService} from '../../projects/api/src/user/profile/profile-api.service';
import {MainTempComponent} from './main-temp/main-temp.component';
import {AuthGuard} from './shared/auth.guard';
import {UserStatusResolverService} from './shared/resolvers/user-status-resolver.service';
import {RedirectComponent} from './components/redirect/redirect.component';
import {MenuHomeComponent} from './main-temp/menu/menu-home/menu-home.component';
import {Error502Component} from '../../projects/common/standalone/502.component';
/*import {main} from '@popperjs/core';*/

/* USTAS */
const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: mainPath},
  {path: '502error', pathMatch: 'full', component: Error502Component},
  {path: 'app/home', redirectTo: mainPath},
  {path: loginPath, loadChildren: () => import('./login/login.module').then(m => m.LoginModule)},
  {path: ssoPath, loadChildren: () => import('./sso/sso.module').then(m => m.SsoModule)},
  {
    path: 'building',
    children: [
      {
        path: '**',
        pathMatch: 'prefix',
        component: RedirectComponent,
        resolve: {
          url: 'externalUrlRedirectResolver'
        }
      }
    ]
  },
  {
    path: 'admin',
    children: [
      {
        path: '**',
        pathMatch: 'prefix',
        component: RedirectComponent,
        resolve: {
          url: 'externalUrlRedirectResolver'
        }
      }
    ]
  },
  {
    path: 'app',
    children: [
      {
        path: '**',
        pathMatch: 'prefix',
        component: RedirectComponent,
        resolve: {
          url: 'externalUrlRedirectResolver'
        }
      }
    ]
  },

  {
    path: mainPath,
    component: MainTempComponent,
    canActivate: [AuthGuard],
    resolve: {loginInfo: UserStatusResolverService},
    children: [
      {
        path: '',
        component: MenuHomeComponent
      },
      {
        path: 'page/home',
        redirectTo: '/' + mainPath
      },
      {/*USTAS*/
            path: 'page/object',
            loadChildren: () => import('../../projects/admin/modules/object/object.module').then(m => m.ObjectModule),
            canActivate: [AuthGuard]
        },
      { /*USELESS*/
        path: userPath,
        loadChildren: () => import('../../src/app/user/user.module').then(m => m.UserModule),
        canActivate: [AuthGuard]
      }, {
        path: 'page/profilesubscription',
        loadChildren: () => import('../../src/app/user/usersubscription/usersubscription.module').then(m => m.UsersubscriptionModule)
      },
      {
        path: 'page/profilenotification',
        loadChildren: () => import('../../src/app/user/usernotification/usernotification.module').then(m => m.UsernotificationModule)
      },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {provide: APP_BASE_HREF, useValue: '!'},
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    {provide: ProfileApiService, useClass: ProfileApiService}
  ]
})
export class AppRoutingModule {
}
